import { Injectable, OnDestroy } from '@angular/core'
import { RouterStateSnapshot, TitleStrategy } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { Title } from '@angular/platform-browser'
import { of, Subscription } from 'rxjs'

@Injectable()
export class CustomPageTitleStrategy extends TitleStrategy implements OnDestroy {
  private titleSubscription?: Subscription

  constructor(
    private translateService: TranslateService,
    private readonly title: Title
  ) {
    super()
  }

  ngOnDestroy(): void {
    this.titleSubscription?.unsubscribe()
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const route = snapshot.root.firstChild
    const titleKey: string = route?.data?.tempTitle ?? ''

    const buildTitle = (translatedTitle: string): string => {
      let title = translatedTitle
      if (route?.data?.hasId && route.params?.id) {
        title += ' ' + route.params.id
      }
      if (route?.data?.prefix && route.params?.id) {
        title += ' ' + this.translateService.instant(route.data.prefix + '.' + route.params.id)
      }
      title += title ? ' - Depoto' : 'Depoto'
      if (window['companyName'] && window['companyName'].length) {
        title += ' [' + window['companyName'] + ']'
      }
      return title
    }

    // stream() emits once the translation file is loaded and again on every language change,
    // so the raw key never reaches the tab and the " - Depoto" suffix is appended exactly once.
    // One subscription per navigation: the previous route must not keep rewriting the title.
    this.titleSubscription?.unsubscribe()
    this.titleSubscription = (titleKey ? this.translateService.stream(titleKey) : of('')).subscribe(translatedTitle =>
      this.title.setTitle(buildTitle(translatedTitle))
    )
  }
}
